/**
 * Criterios para exportar Excel mayorista «limpio» (reimportación) sin depender de SAP services.
 */

/**
 * Fila de vista previa: apta solo si quedó validada **OK** (línea verde). Se excluyen `error` y
 * cualquier `warning` (ítem SAP no encontrado, precio distinto, stock insuficiente, bodega faltante, etc.),
 * de modo que el Excel para reimportar contenga únicamente líneas listas para enviar a SAP.
 * Las verificaciones de precio/stock se mantienen como red de seguridad adicional.
 *
 * @param {object|null|undefined} row
 * @returns {boolean}
 */
export function bulkPreviewRowEligibleForCleanPriceStockExport(row) {
  if (row == null || typeof row !== 'object') return false;
  if (row.validationStatus !== 'ok') return false;
  if (row.sapPriceMismatch) return false;
  const cant = row.cantOc;
  const stk = row.stockDispSap;
  if (
    cant != null &&
    stk != null &&
    Number.isFinite(Number(cant)) &&
    Number.isFinite(Number(stk)) &&
    Number(cant) > Number(stk)
  ) {
    return false;
  }
  return true;
}

/**
 * Por índice de fila en `grid.rows`, indica si incluir la línea de detalle en el Excel «solo líneas OK» (reimportar).
 * Misma alineación que `mapGridRowIndexToBulkValidation`.
 *
 * @param {{ rows?: any[][] }} grid
 * @param {number} headerIndex
 * @param {object[]} previewRows
 * @returns {Map<number, boolean>}
 */
export function mapGridRowIndexToBulkCleanPriceStockExportEligible(grid, headerIndex, previewRows) {
  const rows = grid?.rows || [];
  const map = new Map();
  const hi = Number(headerIndex);
  if (!Number.isFinite(hi) || hi < 0 || !Array.isArray(previewRows)) return map;

  let pi = 0;
  for (let ri = hi + 1; ri < rows.length; ri += 1) {
    const r = rows[ri];
    if (!Array.isArray(r) || !r.some((c) => String(c ?? '').trim())) continue;
    const pr = previewRows[pi];
    pi += 1;
    const eligible = pr == null ? true : bulkPreviewRowEligibleForCleanPriceStockExport(pr);
    map.set(ri, eligible);
  }
  return map;
}
